export const FETCH_DASHBOARD_SUCCESS = 'licensePackages/FETCH_DASHBOARD_SUCCESS';
export const SET_DASHBOARD_LOADING   = 'licensePackages/SET_DASHBOARD_LOADING';
export const SET_SELECTED_COMPANY_ID = 'licensePackages/SET_SELECTED_COMPANY_ID';
export const FETCH_AUDIT_LOG_SUCCESS = 'licensePackages/FETCH_AUDIT_LOG_SUCCESS';
export const SET_AUDIT_LOG_LOADING   = 'licensePackages/SET_AUDIT_LOG_LOADING';
export const FETCH_CONSUMPTION_POLICY_SUCCESS = 'licensePackages/FETCH_CONSUMPTION_POLICY_SUCCESS';
